export { TableOfContents };

let TableOfContents = {

    init() {
        this.initPageLoadAnchorScrolling();
        this.initMobileAutoHide();
        this.initAutoScroll();
        this.initHighlighting();
        this.initAnchors();
    },

    initMobileAutoHide() {
        if (window.screen.width > 991.98) {
            return;
        }

        const btnTocCollapse = document.getElementById("BtnTocCollapseMobile");
        const tocList = document.getElementById("toc-list-mobile");
        const article = document.querySelector(".article");
        const tocDiv = document.querySelector(".table-of-contents.mobile");
        let prevScrollPosition = 0;

        if (!tocList) {
            return;
        }

        btnTocCollapse.addEventListener('click', () => { tocDiv.classList.toggle('show'); });

        //
        // Auto-hide TOC menu on mobile if shown, and a click away from TOC occurs
        //
        document.addEventListener("click", function(event) {
            if (!event.target.closest(".table-of-contents, #BtnTocCollapse")) {
                if (tocList.classList.contains("show")) {
                    tocList.classList.remove("show");
                    tocDiv.classList.remove("show");
                    btnTocCollapse.setAttribute("aria-expanded", "false");
                }
            }
        });

        //
        // Auto-hide TOC on mobile once we get beneath the article
        //
        window.addEventListener('scroll', function() {
            const currentScrollPosition = window.pageYOffset;
            const articleRect = article.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            if (articleRect.bottom - viewportHeight <= 0) {
                tocList.classList.add("hide");
                tocDiv.classList.add("hide");

                const bsCollapse = bootstrap.Collapse.getInstance(tocList);

                if (bsCollapse) {
                    bsCollapse.hide();
                }

                tocDiv.classList.remove("show");
                btnTocCollapse.setAttribute("aria-expanded", "false");
            } else {
                tocList.classList.remove("hide");
                tocDiv.classList.remove("hide");
            }

            prevScrollPosition = currentScrollPosition;
        });
    },

    /**
     * Highlight TOC items as they come in to view
     */
    initHighlighting() {
        const headings = document.querySelectorAll('article.article h2, article.article h3');
        const headingPositions = [];
        let currentHeadingIndex = -1;

        headings.forEach((heading, index) => {
            if (heading.hasAttribute('id')) {
                headingPositions.push({
                    element: heading,
                    top: heading.offsetTop
                });
            }
        });

        window.addEventListener('scroll', function() {
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (let i = 0; i < headingPositions.length; i++) {
                if ((scrollPosition >= headingPositions[i].element.offsetTop && (i === headingPositions.length - 1 || scrollPosition < headingPositions[i + 1].element.offsetTop)) || (currentHeadingIndex === 0 && scrollPosition < headingPositions[0].element.offsetTop)) {
                    if (currentHeadingIndex !== i) {
                        if (currentHeadingIndex !== -1) {
                            const previousHeading = headingPositions[currentHeadingIndex].element;
                            const previousLinks = document.querySelectorAll(`.table-of-contents ul li a[href="#${previousHeading.id}"]`);

                            if (previousLinks.length > 0) {
                                previousLinks.forEach(previousLink => { previousLink.classList.remove('active'); });
                            }
                        }

                        const currentHeading = headingPositions[i].element;
                        const currentLinks = document.querySelectorAll(`.table-of-contents ul li a[href="#${currentHeading.id}"]`);

                        if (currentLinks) {
                            currentLinks.forEach(currentLink => { currentLink.classList.add('active'); });
                        }

                        currentHeadingIndex = i;
                    } else if (currentHeadingIndex === 0 && scrollPosition < headingPositions[0].element.offsetTop) {
                        const firstHeading = headingPositions[0].element;
                        const firstLinks = document.querySelectorAll(`.table-of-contents ul li a[href="#${firstHeading.id}"]`);

                        if (firstLinks) {
                            firstLinks.forEach(firstLink => { firstLink.classList.remove('active'); });
                        }
                    }

                    break;
                }
            }
        });
    },

    /**
     * Scroll to the correct item in TOC if out of view (non-mobile)
     */
    initAutoScroll() {
        if (!window.matchMedia('(min-width: 992px)').matches) {
            return;
        }

        const elements = document.querySelectorAll('.table-of-contents:not(.mobile) ul li a');

        let tocContainer = document.getElementById('TableOfContents'),
            currentTarget;

        elements.forEach(function (element) {
            // Create an observer instance linked to the callback function
            let observer = new MutationObserver(function(mutationsList, observer) {
                mutationsList.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (mutation.target.classList.contains('active')) {
                            const intersectionObserver = new IntersectionObserver(function(entries, observer) {
                                entries.forEach(function(entry) {
                                    if (entry.target.classList.contains('active') && entry.target !== currentTarget && entry.intersectionRatio < 1) {
                                        let targetRect = entry.target.getBoundingClientRect(),
                                            containerRect = tocContainer.getBoundingClientRect();

                                        tocContainer.scrollTop += targetRect.top - containerRect.top - tocContainer.offsetTop - (containerRect.height / 2 - targetRect.height / 2);

                                        currentTarget = entry.target;
                                    }
                                });
                            }, { root: tocContainer, threshold: [0, 1] });

                            intersectionObserver.observe(mutation.target);
                        }
                    }
                });
            });

            const config = { attributes: true };

            observer.observe(element, config);
        });
    },

    initAnchors() {
        const anchors = document.querySelectorAll('.table-of-contents:not(.mobile) ul li a');

        anchors.forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();

                const hash = anchor.getAttribute('href'),
                    targetElement = document.querySelector(hash),
                    lazyImages = Array.from(document.querySelectorAll('article img.lazy'));

                let loadingImages = [];

                lazyImages.forEach(lazyImage => {
                    if (lazyImage.compareDocumentPosition(targetElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
                        if (!!lazyImage.getAttribute("data-ll-status")) {
                            return;
                        }

                        // force load
                        LazyLoad.load(lazyImage);
                        loadingImages.push(lazyImage);
                    }
                });

                if (loadingImages.length > 0) {
                    // wait until loaded
                    const scrollOnceLoaded = (loadingImages) => {
                        let allLoaded = true;

                        loadingImages.forEach((image) => {
                            if (!image.classList.contains('loaded')) {
                                allLoaded = false;
                            }
                        });

                        if (allLoaded) {
                            window.scrollTo(0, targetElement.getBoundingClientRect().top + window.scrollY);
                            history.pushState({}, "", hash);
                        } else {
                            setTimeout(() => scrollOnceLoaded(loadingImages), 50);
                        }
                    };

                    scrollOnceLoaded(loadingImages);
                } else {
                    window.scrollTo(0, targetElement.getBoundingClientRect().top + window.scrollY);
                    history.pushState({}, "", hash);
                }
            });
        });
    },

    initPageLoadAnchorScrolling() {
        const hash = window.location.hash;

        if (!hash) {
            return;
        }

        const targetElement = document.querySelector(hash);

        if (!targetElement) {
            return;
        }

        history.replaceState("", document.title, window.location.pathname + window.location.search);

        const lazyImages = Array.from(document.querySelectorAll('article img.lazy'));

        let loadingImages = [];

        lazyImages.forEach(lazyImage => {
            if (lazyImage.compareDocumentPosition(targetElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
                if (!!lazyImage.getAttribute("data-ll-status")) {
                    return;
                }

                // force load
                LazyLoad.load(lazyImage);
                loadingImages.push(lazyImage);
            }
        });

        if (loadingImages.length > 0) {
            // wait until loaded
            const scrollOnceLoaded = (loadingImages) => {
                let allLoaded = true,
                    totalHeight = 0;

                loadingImages.forEach((image) => {
                    if (!image.classList.contains('loaded')) {
                        allLoaded = false;
                        totalHeight += image.height;
                    }
                });

                if (allLoaded) {
                    window.scrollTo(0, targetElement.getBoundingClientRect().top + window.scrollY);
                } else {
                    setTimeout(() => scrollOnceLoaded(loadingImages), 50);
                }
            };

            scrollOnceLoaded(loadingImages);
        } else {
            window.scrollTo(0, targetElement.getBoundingClientRect().top + window.scrollY);
        }

        history.replaceState("", document.title, window.location.pathname + window.location.search + hash);
    }
}